export default {
  computed: {
    attributeStatsDialog() {
      return {
        attributeData: this.currentAttributeStatsData,
        currentLayerSelectedFeatures: this.currentLayerSelectedFeatures,
      };
    },
  },
  data: () => ({
    attributeStatsLoaded: false,
    attributeStatsVisible: false,
    currentAttributeStatsData: {},
  }),
  methods: {
    showStatsDialog(attribute) {
      this.currentAttributeStatsData = {
        layerId: this.layerId,
        attribute,
      };
      this.attributeStatsLoaded = true;
      this.attributeStatsVisible = true;
    },
  },
};
